export const currencies = ["USD", "BDT", "EUR", "GBP", "INR", "AED", "CAD"] as const;
export type Currency = (typeof currencies)[number];

export const currencyRates: Record<Currency, number> = {
  USD: 1,
  BDT: 122,
  EUR: 0.92,
  GBP: 0.78,
  INR: 86.6,
  AED: 3.67,
  CAD: 1.43,
};

export const currencySymbols: Record<Currency, string> = {
  USD: "$",
  BDT: "৳",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  AED: "د.إ",
  CAD: "C$",
};

export function suggestCurrency(locale: string): Currency {
  const region = locale.split("-")[1]?.toUpperCase();
  if (region === "BD") return "BDT";
  if (region === "GB") return "GBP";
  if (region === "IN") return "INR";
  if (region === "AE") return "AED";
  if (region === "CA") return "CAD";
  if (["AT", "BE", "CY", "DE", "EE", "ES", "FI", "FR", "GR", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PT", "SI", "SK"].includes(region ?? "")) return "EUR";
  return "USD";
}

export function convertUsd(value: number, currency: Currency) {
  return value * currencyRates[currency];
}

export function formatCurrency(value: number, currency: Currency) {
  const converted = convertUsd(value, currency);
  const digits = currency === "BDT" || currency === "INR" ? 0 : 2;
  return `${currencySymbols[currency]}${converted.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

export function updateCurrencyRates(newRates: Partial<Record<Currency, number>>) {
  for (const [k, v] of Object.entries(newRates)) {
    if (k in currencyRates && typeof v === "number" && !isNaN(v) && v > 0) {
      currencyRates[k as Currency] = v;
    }
  }
}

export function formatBdt(value: number) {
  return `৳${convertUsd(value, "BDT").toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
}